import { createAction, handleActions } from 'redux-actions';

/**
 * API 호출시 Loading 중 상태 관리 Module 
 */


/**
 * Action Type 선언 
 */
const START_LOADING = 'loading/START_LOADING';
const FINISH_LOADING = 'loading/FINISH_LOADING';


/**
 * Action 생성 함수 선언 
 * 첫번째 인자 : 액션 타입
 * 두번째 인자 : payload data ( store 에서 사용할 data )
 */
export const startLoading = createAction(
    START_LOADING,
    requestType => requestType
);

export const finishLoading = createAction(
    FINISH_LOADING,
    requestType => requestType
);

/**
 * 초기값 설정 
 */
const initialState = {};

/**
 * 
 */
const loadingReducer = handleActions(
    {
        [START_LOADING]: (state, action) => ({
            ...state,
            [action.payload]: true
        }),
        [FINISH_LOADING]: (state, action) => ({
            ...state,
            [action.payload]: false
        })
    },
    initialState
);

export default loadingReducer;